import ApiClient from '../client';

class MiscAPI extends ApiClient {

  constructor() {
    super();
  }  

  async searchKeywords(query) {
    try {
      const response = await this.get(`taggit/tags/?search=${query}`);
      if (response.status === 200) {
        return response.data;
      }
    }
    catch (err) {
      return false;
    }
  }

  async getSchedulers() {
    const response = await this.get('schedulers/');
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
};

const miscAPI = new MiscAPI();
export default miscAPI;
